<div class="table-responsive">
<table class="table">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Level</th>
    </tr>
  </thead>
  <tbody>
    @for (skill of skills; track skill) {
      <tr>
        <td>{{skill.label}}</td>
        <td>
          <div class="btn-group ">
            @for (level of skillLevels; track level) {
              <label
                class="btn btn-raised skill-button"
                [ngClass]="{'active': skill.level === level.value}"
                (click)="skill.level = level.value; triggerChange()"
                >
                <input type="radio" autocomplete="off"> {{level.label}}
              </label>
            }
          </div>
        </td>
        <td>
          <div>
            <div class="input-group" style="display: flex; flex-direction: column; align-items: center;">
              <div class="togglebutton" style="text-align: center;">
                <label [class.label-grey]="!skill.mayBeInterested">
                  Would like training?
                  <input type="checkbox" id="training" [(ngModel)]="skill.mayBeInterested" name="training"
                    (change)="triggerChange()">
                  </label>
                </div>
                <div>
                  <label class="switch">
                    <input type="checkbox" [(ngModel)]="skill.mayBeInterested" name="all-day" (change)="triggerChange()">
                    <div class="slider round"></div>
                  </label>
                </div>
              </div>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
